<template>
  <div class="app">
    <Header></Header>
    <div class="banner2">
      <div class="mid">
          <div style="text-align: center;margin-top: 100px;"><a href="" class="sctp_btn">上传图片</a></div>
          <div class="js003">点击图片上传，支持jpg,jpeg,png,gif等格式</div>
      </div>
    </div>

    <div class="mid">




      <div class="about-main-box">
        <div class="about-box">
          <el-divider><span class="bd-divider" style="font-size: 24px;font-weight: 200;letter-spacing: 5px;">天天短网址的优势-数据统计</span></el-divider>
          <div class="about-s"><div class="about-s-main"><i style="color:green;" class="iconfont icon-dwzzhexiantu"></i> <b>访问量统计</b> <p>可以精准统计链接的IP，UV,PV 等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#a64ec6;" class="iconfont icon-dwzshuju"></i> <b>地域统计</b> <p>一目了然统计链接访问的地图省份地域</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0B5E6D;" class="iconfont icon-dwzliebiao"></i> <b>客户端统计</b> <p>phone,安卓,mac ,windows等</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzbianji"></i> <b>浏览器统计</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0000ff;" class="iconfont icon-dwzchart-pie"></i> <b>运营商统计i</b> <p>统计网络电信运营商，如移动联通电信长城等</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0b9108;" class="iconfont icon-dwzliebiao"></i> <b>高频IP统计</b> <p>统计列出top前10访问量最大的IP地址</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#d81e06;" class="iconfont icon-dwzmenu"></i> <b>访问记录明细</b> <p>所有访问记录呈现并永久保存到云端</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzzhexiantu"></i> <b>图标显示统计数据</b> <p>chrome,QQ浏览器，uc浏览器，微博客户端等</p></div>  </div>

          <div class="about-s"><div class="about-s-main"><i style="color:#1c6a9e;" class="iconfont icon-dwzRectangleCopy38"></i> <b>单次批量转换</b> <p>一次可以批量转换几十条甚至上百条 </p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#6ea7d0;" class="iconfont icon-dwzRectangleCopy31"></i> <b>数量限制</b> <p>可转换的数量远高于同行</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#491217;" class="iconfont icon-dwzRectangleCopy33"></i> <b>多链接随机</b> <p>可多条链接随机设定和展示</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#4eccc4;" class="iconfont icon-dwzelectronics"></i> <b>智能策略-PC识别</b> <p>可设定电脑和手机打开不一样的链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0F3A56;" class="iconfont icon-dwzRectangleCopy18"></i> <b>智能策略-移动设备识别</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0A246A;" class="iconfont icon-dwzRectangleCopy34"></i> <b>智能策略-地理位置策略</b> <p>可根据地理位置设定不同的链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#1AAD19;" class="iconfont icon-dwzcolumn-horizontal"></i> <b>智能策略-微信浏览器识别</b> <p>可在微信浏览器识别，并自定义访问</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#00a249;" class="iconfont icon-dwzRectangleCopy40"></i> <b>管理短网址</b> <p>可修改删除随时管理短链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#daa726;" class="iconfont icon-dwzRectangleCopy36"></i> <b>设置短网址访问密码</b> <p>可设置用户访问查看的密码</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzexport"></i> <b>修改短网址指向</b> <p>随时可自由修改源链接</p> </div> </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#00b800;" class="iconfont icon-dwzRectangleCopy38"></i> <b>高级功能-不同地区指向网址</b> <p>可根据不同区域设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#514721;" class="iconfont icon-dwzRectangleCopy10"></i> <b>高级功能-不同设备指向网址</b> <p>可根据不同设备设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#BD362F;" class="iconfont icon-dwzRectangleCopy"></i> <b>高级功能-提示浏览器打开</b> <p>可根据不同浏览器设定不一样的落地链接</p></div>  </div>
          <div class="about-s"><div class="about-s-main"><i style="color:#0C5F9B;" class="iconfont icon-dwzcode"></i> <b>API接口转换</b> <p>可使用API接口批量转换</p></div>  </div>
          <div class="clear"></div>

        </div>
      </div>


    </div>

    <Foot ref="foot" ></Foot>


  </div>




</template>

<script>
import QRCode from "qrcodejs2";
import Header from "./header";
import Foot from "./foot";

export default {
  name: "SourceBuy",
  components: {Header,Foot},
  data() {
    return {
      payType: 1,
      isVip: false,
      isGuest: true,
      user_info: {},
      isLoading1: false,
      qrUrl: "",
      qrInterval: null,
      qrExpireSeconds: 0,
      qrExpireDateTxt: "未获取",
      payDialog: false,
    }
  },
  mounted() {
    const token = this.$storeLocal.get('token');
    const user_info = this.$storeLocal.get('userInfo');
    const times = Date.parse(new Date())/1000;

    if (token !== null && token !== '' && token !== undefined) {
      if (user_info.expire_date > times){
        this.isVip = true;
      }
      this.isGuest = false;
      this.user_info = user_info;
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.app{
  height: auto;
  background-color: #f5f5f5;
}

.mid{
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding-top: 20px;
}
.mid .recharge{
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #ffffff;
}
.mid .recharge .bd-divider{
  font-size: 24px;
  font-weight: 200;
  letter-spacing: 5px;
}
.mid .recharge .exclu-list{
  padding: 30px 0;
}
.exclu-list .exclu-item{

  color: #000000;
  border-radius: 8px;
  margin: 10px auto;
  border: 1px solid #e7e7e7;
  font-size: 18px;
  padding:20px 20px;
}
.exclu-list .exclu-item div{
  display: inline-block;
  vertical-align: top;
}
.exclu-list .exclu-item div.l{
  width: 60px;
  height: 40px;
  margin: 30px 10px;
}
.exclu-list .exclu-item div.m{
  width: 320px;
  height: 100px;
  color: #505050;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  line-height: 100px;
}
.exclu-list .exclu-item div.r{
  color: #999999;
  font-size: 18px;
  line-height: 100px;
}
.exclu-list .exclu-item a{color:#0c60ee;}
.exclu-list .btn-box{
  width: 100%;
  height: auto;
  text-align: center;
  padding-top: 20px;
}
.footer{
  color: #666666;
  text-align: center;
  line-height: 114px;
}

.jietu_list a{width:190px;height:370px;background:#efefef;border:1px solid #eee;display:block;float:left;margin:10px;text-align: center; position: relative;}
.jietu_list a p{color:#333;font-size:14px;line-height: 200%; position: absolute;width:100%;bottom:0px;left:0px;}
.jietu_list img{width:170px;max-height:320px;margin-top:10px;}
.jietu_list_one a{height:160px;}


.pay-qrcode{
  width: 200px;
  height: 200px;
  margin: 0 auto;
  position: relative;
}
.pay-qrcode .code-div{
  width: 100%;
  height: 100%;
}
.pay-qrcode .icon-box{
  width: 40px;
  height: 40px;
  margin: -20px 0 0 -20px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  line-height: 40px;
  background-color: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
}
.pay-qrcode .icon-box i{
  font-size: 40px;
}
.pay-qrcode .icon-box i.zfb{
  color: #1196db;
}
.pay-qrcode .icon-box i.wx{
  color: #00c800;
}
.header{
  width: 100%;
  height: 40px;
  font-size: 16px;
  text-align: center;
}
.api-list{background:#f8f8f8;color:#000;}

.tb22 {border-collapse: collapse;width:100%;background:#fff;}
.tb22 td,.tb22 th{border: 1px solid #fff;padding:10px;font-size: 14px;}
.tb22 tr th{background:#51a3ee;color:#fff;}
.tb22 .th22 td{background:#cce4f7;color:#095ba6;font-size:18px;}
.tb22 td{background:#f4fafe ;}
.tb22 .td33 td{background:#e7f5fe !important;}
.go_alink{color:#0c60ee;}

.banner2{background:#eee;min-height: 300px;}

.sctp_btn{border-radius: 30px;background:#3c8fe7;color:#fff;padding:15px 30px;font-size: 20px;}
.js003{margin-top:30px; text-align: center;font-size:20px;color:#999;}

.clear{clear: both;}
.about-main-box{padding: 20px 60px 60px 60px;width:1080px;background-color: #FFFFFF;overflow: hidden;margin: 20px auto 0 auto;}
.about-box{margin-top: 50px;}
.about-box .index-title2{padding: 0px 0px;font-size: 14px;color:#333;margin-top:20px;font-weight: bolder;}
.about-box .about-s{width:260px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
.about-box .about-s .about-s-main{padding:15px;}
.about-box .title2{font-weight: bold;padding:20px 0;}
.about-box .about-s b{font-size:14px;font-weight: bold;color:#727888;}
.about-box i{font-size:20px;   }
.about-box p{font-size: 14px;color: #727888;}
</style>
